// extracted by mini-css-extract-plugin
export var categoryName = "category-card-module--category-name--+hOhK";
export var container = "category-card-module--container--HrpuB";
export var content = "category-card-module--content--2yJCM";
export var cover = "category-card-module--cover--D3rta";
export var hoverContent = "category-card-module--hover-content--o34ak";
export var hoverRatio = "category-card-module--hover-ratio--qsH5d";
export var noCoverImage = "category-card-module--no-cover-image--MTy68";
export var noHoverImage = "category-card-module--no-hover-image--g0BAK";
export var ratio = "category-card-module--ratio--OJkJ8";